import { Container, Grid, GridItem, Text } from '@chakra-ui/react';
import { Footer, WishlistBox } from 'components';
import { FAVORITES_DEMO } from 'data';

const Wishlist = () => {
  return (
    <>
      <Container maxW='container.xl' padding='1.5rem 3rem'>
        <Text fontSize="42px" fontFamily="Montserrat" fontWeight={700}>Favorites</Text>
      </Container>
      <Container maxW='container.xl'>
        <Grid templateColumns='repeat(auto-fit, minmax(400px, 1fr))' gap={6} justifyItems='center'>
          {FAVORITES_DEMO.map((data) => (
            <GridItem key={data.id}>
              <WishlistBox data={data} />
            </GridItem>
          ))}
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export { Wishlist };
